// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'

// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Selectors
import { users$ } from 'fc-users'

// Exports
export default createSelector(
  [users$],
  function (users) {
    return emptyArrayOr(_map(users, (user) => {
      return {value: user.id, label: `${user.first} ${user.last}`}
    }))
  }
)
